<div class="header-title-dash" style="margin-top: 30px">{{'' | i18n: 'promotions'}}.</div>
<div class="form-row-container">

  @if (promotions) {
    <div class="form-row-container-prom">
      <div class="table-header-prom">
        <div class="table-header-item-status">
          <a (click)="orderBy('contractType')">{{'' | i18n: 'warranty-type'}}@if (filter.orderBy == 'contractType') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('brand')">{{'' | i18n: 'contract-duration'}}@if (filter.orderBy == 'brand') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('brand')">{{'' | i18n: 'brand'}}@if (filter.orderBy == 'brand') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('model')">{{'' | i18n: 'order-date-from'}}@if (filter.orderBy == 'model') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('contractType')">{{'' | i18n: 'order-date-to'}}@if (filter.orderBy == 'contractType') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('contractCode')">{{'' | i18n: 'discount'}}@if (filter.orderBy == 'contractCode') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('warrantyNumber')">{{'' | i18n: 'dealer-regions'}}@if (filter.orderBy == 'warrantyNumber') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('contractStartDate')">{{'' | i18n: 'dealers'}}@if (filter.orderBy == 'contractStartDate') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('contractEndDate')">{{'' | i18n: 'model-codes'}}@if (filter.orderBy == 'contractEndDate') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('contractMileage')">{{'' | i18n: 'description'}}@if (filter.orderBy == 'contractMileage') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
        <div class="table-header-item-status">
          <a (click)="orderBy('contractMileage')">{{'' | i18n: 'attachment'}}@if (filter.orderBy == 'contractMileage') {
            <img src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a>
        </div>
      </div>
      @for (r of promotions; track r) {
        <div class="table-list">
          <div class="table-list-item-status ellipsis">{{ r.contractType }}</div>
          <div class="table-list-item-status ellipsis">{{ r.contractDuration }}</div>
          <div class="table-list-item-status ellipsis">{{ r.brand }}</div>
          <div class="table-list-item-status ellipsis">{{ r.dateFrom }}</div>
          <div class="table-list-item-status ellipsis">{{ r.dateTo }}</div>
          <div class="table-list-item-status ellipsis">{{ r.discountFactor }}</div>
          <div class="table-list-item-status ellipsis">{{ r.dealerRegions }}</div>
          <div class="table-list-item-status ellipsis">{{ r.dealers }}</div>
          <div class="table-list-item-status ellipsis">{{ r.modelCodes }}</div>
          <div class="table-list-item-status ellipsis">{{ r.description }}</div>
          <div class="table-list-item-status ellipsis" style="margin-left: 10px">
            @for (d of r.documentUrls; track d) {
              <a>
                <i class="fa fa-paperclip" aria-hidden="true" (click)="downloadPromotionFile(r.id, d)"></i>
              </a>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
